

import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <nav className="bg-white shadow-md fixed w-full top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <h1 className="text-3xl font-bold text-zinc-900" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>
              SENECA TIRE SHOP
            </h1>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <a href="#home" className="hover:text-orange-500 transition-colors cursor-pointer whitespace-nowrap">Home</a>
            <a href="#services" className="hover:text-orange-500 transition-colors cursor-pointer whitespace-nowrap">Services</a>
            <a href="#products" className="hover:text-orange-500 transition-colors cursor-pointer whitespace-nowrap">Products</a>
            <a href="#about" className="hover:text-orange-500 transition-colors cursor-pointer whitespace-nowrap">About</a>
            <a href="#contact" className="hover:text-orange-500 transition-colors cursor-pointer whitespace-nowrap">Contact</a>
            <button className="bg-orange-600 hover:bg-orange-700 px-6 py-2.5 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap">
              Get Quote
            </button>
          </div>

          {/* Mobile menu button */}
          <button 
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden pb-4 space-y-3">
            <a href="#home" className="block hover:text-orange-500 transition-colors cursor-pointer py-2">Home</a>
            <a href="#services" className="block hover:text-orange-500 transition-colors cursor-pointer py-2">Services</a>
            <a href="#products" className="block hover:text-orange-500 transition-colors cursor-pointer py-2">Products</a>
            <a href="#about" className="block hover:text-orange-500 transition-colors cursor-pointer py-2">About</a>
            <a href="#contact" className="block hover:text-orange-500 transition-colors cursor-pointer py-2">Contact</a>
            <button className="w-full bg-orange-600 hover:bg-orange-700 px-6 py-2.5 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap mt-2">
              Get Quote
            </button>
          </div>
        )}
      </div>
    </nav>
  );
}

